import { useMemo } from "react";
import { useQueryResult } from "src/utils/results/useQueryResult";
import { unique } from "src/utils/array";

import type { Parameter } from "src/utils/parameters/types";

export function useParameterEnumOptions(
  parameter: Parameter
): Parameter["enumOptions"] {
  const queryResult = useQueryResult(parameter.enumFromResults?.queryId, [], {
    can_refresh: false,
  });

  return useMemo(() => {
    if (parameter.type !== "enum") {
      return undefined;
    }

    if (parameter.enumFromResults === undefined) {
      return parameter.enumOptions;
    }

    if (!queryResult.matrix) {
      // Loading queryResult
      return undefined;
    }

    const { columns, rows } = queryResult.matrix;
    const { columnName } = parameter.enumFromResults;
    const columnExists = columns.some((column) => column.name === columnName);

    if (!columnExists) {
      return undefined;
    }

    const options = rows.map((row) => row[columnName]).map(String);

    return options.length < 10_000 ? options.filter(unique) : options;
  }, [
    queryResult.matrix,
    parameter.type,
    parameter.enumFromResults === undefined,
    parameter.enumFromResults?.columnName,
    parameter.enumOptions,
  ]);
}
